import React from 'react';
import { AsyncSelect } from '../../../../../../../../../components/Select/async';
import { QuestionSelectOption } from '../utils';

interface QuestionSelectorProps {
  isLoading: boolean;
  loadOptions: (inputValue: string) => Promise<QuestionSelectOption[]>;
  onChange: (option: QuestionSelectOption | null) => void;
  getSelectedQuestionOption: () => QuestionSelectOption | null;
}

export function QuestionSelector({
  isLoading,
  loadOptions,
  onChange,
  getSelectedQuestionOption,
}: QuestionSelectorProps) {
  return (
    <AsyncSelect
      loadOptions={loadOptions}
      selected={getSelectedQuestionOption()}
      disabled={isLoading}
      onChange={onChange}
      placeholder='Select Question'
      isSearchable={true}
      isClearable={true}
      isLoading={isLoading}
    />
  );
}
